import React from "react";
import LongShortChart from "../Charts/LongShortChart";

const LongShortComparisonChart = ({ data }) => {
  const labels = data && data?.map((item) => item[0]);
  const seriesData =
    data && data?.map((item) => Number(item[1]?.results).toFixed(2));
  const name = "P&L";

  return (
    <>
      <LongShortChart labels={labels} seriesData={seriesData} name={name} />
    </>
  );
};

export default LongShortComparisonChart;
